import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class Product extends MongoEntity {
  static override _class = 'Product';
  static override _collectionName = 'products';

  // Basic product identification
  @Field(() => String) materialNumber?: Maybe<string>;

  // Product categorization
  @Field(() => String) productGroupNumber?: Maybe<string>;
  @Field(() => String) productGroup?: Maybe<string>;

  // Material properties
  @Field(() => String) material?: Maybe<string>;
  @Field(() => String) deliveryCondition?: Maybe<string>;

  // Physical dimensions
  @Field(() => Float) outerDiameterOne?: Maybe<number>;
  @Field(() => Float) outerDiameterTwo?: Maybe<number>;
  @Field(() => Float) wallThickness?: Maybe<number>;
  @Field(() => Float) innerDiameter?: Maybe<number>;

  // Handelslängen-Range (mm)
  @Field(() => Float) hlMin?: Maybe<number>;
  @Field(() => Float) hlMax?: Maybe<number>;

  constructor(data: Partial<Product>) {
    super(data);
    Object.assign(this, data);
  }
}
